import {Component, computed, inject} from '@angular/core';
import {PageTitleComponent} from "../../../components/page-title/page-title.component";
import {Button} from "primeng/button";
import {UserService} from "../../../services/user.service";
import {HomeyDialogService} from "../../../services/homey-dialog.service";
import {ChangePasswordModalComponent} from "./change-password-modal/change-password-modal.component";
import {AuthService} from "../../../services/auth/auth.service";
import {Divider} from "primeng/divider";
import {toSignal} from "@angular/core/rxjs-interop";
import {from} from "rxjs";

@Component({
  standalone: true,
  imports: [
    PageTitleComponent,
    Button,
    Divider
  ],
  templateUrl: './account-security-page.component.html',
})
export class AccountSecurityPageComponent {
  private readonly homeyDialogService = inject(HomeyDialogService);
  private readonly userService = inject(UserService);
  private readonly authService = inject(AuthService);
  protected readonly loginMethod = toSignal(from(this.authService.getLoginMethod()));

  protected readonly email = computed(
    () => {
      const user = this.userService.user();
      if (user && user.status !== 'unauthorized') {
        return user.email;
      } else {
        return undefined;
      }
    }
  )

  onChangePasswordClick() {
    this.homeyDialogService.showDialogWithHeader(
      ChangePasswordModalComponent,
      "Change password",
      {}
    )
  }
}
